export default __webpack_public_path__ + "static/media/Home Shifting2.f0b3130b.jpg";